module.exports = __webpack_public_path__ + "static/medograf-footerBanner-540f060ffc64ecb7796fec897e232275.jpg";